module.exports = __webpack_public_path__ + "media/LaughingMonkey.f37434d5.mp4";